function dateDiff(startingDate, endingDate) {

    endingDate = new Date().toISOString().substr(0, 10);  // need date in YYYY-MM-DD format

    const 
    //dom elements to change
    daysEl = document.querySelector('.js-history-counter-days'),
    monthsEl = document.querySelector('.js-history-counter-months'),
    yearsEl = document.querySelector('.js-history-counter-years'),


    //dates
    startDate = new Date(new Date(startingDate).toISOString().substr(0, 10)),
    endDate = new Date(endingDate),

    //leap year and days in months shiz
    startYear = startDate.getFullYear(),
    february = (startYear % 4 === 0 && startYear % 100 !== 0) || startYear % 400 === 0 ? 29 : 28,
    daysInMonth = [31, february, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    //get the difference between start year and endyear
    let yearDiff = endDate.getFullYear() - startYear,
    monthDiff = endDate.getMonth() - startDate.getMonth(),
    dayDiff = endDate.getDate() - startDate.getDate();

    //calcs based on months in year / days in months
    if (monthDiff < 0) {
        yearDiff--;
        monthDiff += 12;
    }

    if (dayDiff < 0) {
        if (monthDiff > 0) {
            monthDiff--;
        } else {
            yearDiff--;
            monthDiff = 11;
        }
        dayDiff += daysInMonth[startDate.getMonth()];
    }

    //changing dom els to be the difference between opening date and now

    daysEl.innerHTML =  dayDiff + '&nbsp;';
    monthsEl.innerHTML = monthDiff + '&nbsp;';
    yearsEl.innerHTML = yearDiff + '&nbsp;';

}

function formatDate() {
    const startingDay = document.querySelector('.js-opening-day'),
     startingMonth = document.querySelector('.js-opening-month'),
     startingYear = document.querySelector('.js-opening-year'),
     formattedStartingDate = startingYear.textContent + '-' +  startingMonth.textContent + '-' +  startingDay.textContent;

    dateDiff(formattedStartingDate)
}
